<template>
    <div class="">
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <div class="vx-card p-4">
                    <div class="vx-row">
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                            <label class="vs-input--label">{{ $t('navMenu.branch') }}</label>
                            <v-select v-model="organizationBranchModel" :options="branchOptions"></v-select>
                        </div>
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                            <label class="vs-input--label">{{ $t("minioStorage.dateRange") }}</label>
                            <date-range-picker ref="picker" :locale-data="{ format: 'dd/mm/yyyy' }" :opens="'right'"
                                               v-model="dateRange" :timePicker="true" :autoApply="true"
                                               class="w-full" @update="dateRangePicker">
                            </date-range-picker>
                        </div>
                        <!--                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-0 mt-2">-->
                        <!--                            <label class="vs-input&#45;&#45;label">{{ $t('cardCustomer.customerType') }}</label>-->
                        <!--                            <v-select v-model="customerTypeModel" :options="customerTypes"></v-select>-->
                        <!--                        </div>-->
                        <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-6 md:mt-4 sm:mt-8 mt-4">
                            <vs-button icon-pack="feather" icon="icon-search" @click.prevent="search">{{
                                    $t('cardCustomer.search')
                                }}
                            </vs-button>
                        </div>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col lg:w-3/4 md:w-2/3 w-1/2">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full text-right">
                                <span class="font-bold">Hiển thị: </span>
                                <span class="">
              {{
                                        customerLoyaltyData.length > 0 ? pageDataLoyalty.numberOfElements + pageDataLoyalty.size * pageDataLoyalty.number : 0
                                    }} / {{ pageDataLoyalty.totalElements }}
                                </span>
                            </div>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <div class="vx-card mt-4 pt-2 pl-4">
                                    <div class="vx-row">
                                        <div class="vx-col w-full">
                                            <div class="pl-2">
                                                <div class="w-full" v-if="customerLoyaltyData.length > 0">
                                                    <div class="vx-row match-height">
                                                        <div class="vx-col w-full" id="loyalty_data">
                                                            <VuePerfectScrollbar ref="scrollDialog"
                                                                                 class="scroll-area--nofications-dropdown size-content vx-row w-full"
                                                                                 :settings="settings"
                                                                                 style="max-height: 80vh">
                                                                <div class=" table_realtime vx-col  lg:w-1/3 md:w-1/2 w-full"
                                                                     v-for="(data, index) in customerLoyaltyData"
                                                                     :key="index"
                                                                     @mouseover="pauseCall" @mouseleave="resumeCall">
                                                                    <card-realtime class="mt-2 " :data="data"/>
                                                                </div>
                                                            </VuePerfectScrollbar>
                                                        </div>
                                                    </div>
                                                    <div class="vx-row mt-4 px-4">
                                                        <div class="vx-col md:w-1/2 w-full">
                                                            <div
                                                                class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                                                                <span
                                                                    class="vx-col mt-2 font-bold">Số phần tử / trang:</span>
                                                                <vs-dropdown vs-trigger-click class="cursor-pointer">
                                                                    <div
                                                                        class="p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                  <span class="mr-2">
                                    {{ pageSizeLoyalty }}
                                  </span>
                                                                        <feather-icon icon="ChevronDownIcon"
                                                                                      svgClasses="h-4 w-4"/>
                                                                    </div>
                                                                    <vs-dropdown-menu>
                                                                        <vs-dropdown-item
                                                                            @click="setPageSizeLoyalty(20)">
                                                                            <span>20</span>
                                                                        </vs-dropdown-item>
                                                                        <vs-dropdown-item
                                                                            @click="setPageSizeLoyalty(40)">
                                                                            <span>40</span>
                                                                        </vs-dropdown-item>
                                                                        <vs-dropdown-item
                                                                            @click="setPageSizeLoyalty(60)">
                                                                            <span>60</span>
                                                                        </vs-dropdown-item>
                                                                        <vs-dropdown-item
                                                                            @click="setPageSizeLoyalty(80)">
                                                                            <span>80</span>
                                                                        </vs-dropdown-item>
                                                                        <vs-dropdown-item
                                                                            @click="setPageSizeLoyalty(100)">
                                                                            <span>100</span>
                                                                        </vs-dropdown-item>
                                                                    </vs-dropdown-menu>
                                                                </vs-dropdown>
                                                            </div>
                                                        </div>
                                                        <div class="vx-col md:w-1/2 w-full">
                                                            <vs-pagination :total="totalPagesLoyalty"
                                                                           v-model="currentPageLoyalty"
                                                                           @change="changePageLoyalty"
                                                                           @mouseover="pauseCall"
                                                                           @mouseleave="resumeCall"></vs-pagination>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="w-full text-center" v-else style="min-height: 100px">
                                                    <span class="mt-2">{{ $t('menuCustomer.noRowsToShow') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 md:w-1/3 w-1/2">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full text-right">
                                <span class="font-bold">Hiển thị: </span>
                                <span class="">
              {{
                                        customerUnknownData.length > 0 ? pageDataUnknown.numberOfElements + pageDataUnknown.size * pageDataUnknown.number : 0
                                    }} / {{ pageDataUnknown.totalElements }}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <div class="vx-card mt-4 pt-2 pl-4">
                                    <div class="vx-row" id="unknown_data">
                                        <div class="vx-col w-full">
                                            <div class="pl-2">
                                                <div class="w-full" v-if="customerUnknownData.length > 0">
                                                    <div class="vx-row">
                                                        <div class="vx-col w-full">
                                                            <VuePerfectScrollbar ref="scrollDialog"
                                                                                 class="scroll-area--nofications-dropdown size-content vx-row w-full"
                                                                                 :settings="settings"
                                                                                 style="max-height: 80vh">
                                                                <div
                                                                    class="table_realtime vx-col  w-full "
                                                                    v-for="(data, index) in customerUnknownData"
                                                                    :key="index"
                                                                    @mouseover="pauseCall" @mouseleave="resumeCall">
                                                                    <card-realtime class="mt-2" :data="data"/>
                                                                </div>
                                                            </VuePerfectScrollbar>
                                                        </div>
                                                    </div>
                                                    <div class="vx-row mt-4 px-4">
                                                        <div class="vx-col md:w-auto w-full xl:w-auto lg:w-auto">
<!--                                                            <div-->
<!--                                                                class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">-->
<!--                                                                <span-->
<!--                                                                    class="vx-col mt-2 font-bold lg:w-auto">Số phần tử / trang:</span>-->
<!--                                                                <vs-dropdown vs-trigger-click class="cursor-pointer">-->
<!--                                                                    <div-->
<!--                                                                        class=" p-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">-->
<!--                                  <span class="mr-2">-->
<!--                                    {{ pageSizeUnknown }}-->
<!--                                  </span>-->
<!--                                                                        <feather-icon icon="ChevronDownIcon"-->
<!--                                                                                      svgClasses="h-4 w-4"/>-->
<!--                                                                    </div>-->
<!--                                                                    <vs-dropdown-menu>-->
<!--                                                                        <vs-dropdown-item-->
<!--                                                                            @click="setPageSizeUnknown(20)">-->
<!--                                                                            <span>20</span>-->
<!--                                                                        </vs-dropdown-item>-->
<!--                                                                        <vs-dropdown-item-->
<!--                                                                            @click="setPageSizeUnknown(40)">-->
<!--                                                                            <span>40</span>-->
<!--                                                                        </vs-dropdown-item>-->
<!--                                                                        <vs-dropdown-item-->
<!--                                                                            @click="setPageSizeUnknown(60)">-->
<!--                                                                            <span>60</span>-->
<!--                                                                        </vs-dropdown-item>-->
<!--                                                                        <vs-dropdown-item-->
<!--                                                                            @click="setPageSizeUnknown(80)">-->
<!--                                                                            <span>80</span>-->
<!--                                                                        </vs-dropdown-item>-->
<!--                                                                        <vs-dropdown-item-->
<!--                                                                            @click="setPageSizeUnknown(100)">-->
<!--                                                                            <span>100</span>-->
<!--                                                                        </vs-dropdown-item>-->
<!--                                                                    </vs-dropdown-menu>-->
<!--                                                                </vs-dropdown>-->
<!--                                                            </div>-->
                                                        </div>
                                                        <div class="vx-col md:ml-8 w-full xl:ml-2 lg:ml-2">
                                                            <vs-pagination :total="totalPagesUnknown"
                                                                           v-model="currentPageUnknown"
                                                                           :max="5"
                                                                           @change="changePageUnknown"
                                                                           @mouseover="pauseCall"
                                                                           @mouseleave="resumeCall"></vs-pagination>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="w-full text-center" v-else style="min-height: 100px">
                                                    <span class="mt-2">{{ $t('menuCustomer.noRowsToShow') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import authConfig from "@/../auth_config.json";
import moment from "moment";
import CardRealtime from "./card-realtime/CardRealtime.vue";
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import CellRendererImageCustomer from "./cell-renderer/CellRendererImageCustomer.vue";
import DateRangePicker from "../../../../components/vue2-daterange-picker/components/DateRangePicker.vue";
import vSelect from 'vue-select'

export default {
    components: {
        moment,
        CardRealtime,
        AgGridVue,
        VuePerfectScrollbar,
        CellRendererImageCustomer,
        DateRangePicker,
        vSelect,
    },
    data() {
        return {
            imageDefault: require('@/assets/images/card/businessman.jpeg'),
            customerInfo: {},
            branchOptions: [],
            customerTypes: [
                {value: ["loyalty-customer", "unknown"], label: this.$t('cardCustomer.allCard')},
                {value: ["loyalty-customer"], label: this.$t('cardCustomer.customer'), valueNumber: 0},
                {value: ["unknown"], label: this.$t('cardCustomer.unknown'), valueNumber: 1},
            ],
            dateRange: {
                endDate: new Date(new Date().setHours(23, 59, 59,999)),
                startDate: new Date(new Date().setHours(0, 0, 0,0)),
            },
            listBranch: [],
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            dataRealtime: {},
            showImg: false,
            searchQuery: "",
            components: {},
            customers: [],
            customerUnknownData: [],
            customerLoyaltyData: [],
            branchId: null,
            faceType: null,
            stopInterval: null,
            currentPageLoyalty: 1,
            pageNumberLoyalty: 0,
            pageSizeLoyalty: 30,
            totalPagesLoyalty: 1,
            totalElementsLoyalty: 0,
            pageDataLoyalty: {},
            currentPageUnknown: 1,
            pageNumberUnknown: 0,
            pageSizeUnknown: 30,
            totalPagesUnknown: 1,
            totalElementsUnknown: 0,
            pageDataUnknown: {},
            heightCard: null,
            dataBooking: [],
            isOpenDetailsCustomer: false,
        };
    },
    computed: {
        organizationBranchModel: {
            get() {
                let object = this.branchOptions.find(el => el.value === this.branchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.branchId = object ? object.value : null;
                this.pageNumberLoyalty = 0;
                this.pageNumberUnknown = 0;
            }
        },
        // customerTypeModel: {
        //     get() {
        //         let object = this.customerTypes.find(el => el.value === this.faceType);
        //         if (!object) return;
        //         return {
        //             label: object.label,
        //             value: object.value
        //         }
        //     },
        //     set(object) {
        //         this.faceType = object ? object.value : null;
        //         this.pageNumber = 1;
        //     }
        // },
    },
    async created() {

        let listBranch = JSON.parse(localStorage.getItem("branchInfoList") || []);
        this.listBranch = listBranch;
        this.branchOptions = listBranch.map(el => {
            return {
                value: el.id,
                label: el.organizationBranchName
            }
        })
        this.branchOptions.unshift({value: null, label: 'Tất cả'});
        this.customerTypeModel = this.customerTypes[0]
        // await this.getCustomers();
        await this.getDataBooking();
        this.$vs.loading();
        await this.filter();
        this.stopInterval = setInterval(async () => {
            await this.getDataBooking();
            this.filter();
        }, 20000);
    },

    methods: {
        async filter() {
            await this.getLoyaltyCustomer();
            await this.getUnknownCustomer();
            // this.heightCard = document.getElementById('loyalty_data').scrollHeight;
        },

        getLoyaltyCustomer() {
            return new Promise((resolve, reject) => {
                let searchInfo = {
                    start: this.dateRange.startDate,
                    end: this.dateRange.endDate,
                    organizationBranchId: this.branchId,
                    faceTypes: ["loyalty-customer"],
                    // pageNumber: this.pageNumberLoyalty,
                    // pageSize: this.pageSizeLoyalty
                }
                this.customerLoyaltyData = []
                let url = `/processor/in-out-history/all?page=${this.pageNumberLoyalty}&size=${this.pageSizeLoyalty}`
                this.$vs.loading()
                this.$processor.post(url, searchInfo).then((response) => {
                    let customerData = response.data.content.map((item) => {
                        item.checkinTime = item.createdAt ? moment(item.createdAt).format("HH:mm DD/MM/YYYY") : null
                        if (item.faceType === "loyalty-customer") item.customerType = this.$t('cardCustomer.customer')
                        if (item.loyaltyCustomer) item.cardRankName = item.loyaltyCustomer.card.settingOrganizationCards[item.loyaltyCustomer.card.currentCardRankIndex].name
                        let branch = this.listBranch.find(
                            (el) => el.id === item.organizationBranchId
                        );
                        if (branch)
                            item.organizationBranchName = branch.organizationBranchName;
                        return item
                    }, []);
                    if (customerData) {
                        this.customerLoyaltyData = customerData
                        this.customerLoyaltyData = this.customerLoyaltyData.filter(el => el.faceType === 'loyalty-customer').slice(0, 20)
                        let compare = JSON.stringify(this.customerLoyaltyData) === JSON.stringify(customerData)
                        if (!compare || this.totalPagesLoyalty !== response.data.totalPages || this.pageSizeLoyalty !== response.data.size || this.totalElementsLoyalty !== response.data.totalElements) {
                            this.pageDataLoyalty = response.data
                            this.totalPagesLoyalty = response.data.totalPages
                            this.totalElementsLoyalty = response.data.totalElements
                            this.customerLoyaltyData = customerData.filter(el => el.faceType === 'loyalty-customer')
                            this.customerLoyaltyData.forEach(el => {
                                let booking = this.dataBooking.find(x => x.loyaltyCustomer.id === parseInt(el.employeeId, 10))
                                if (booking) {
                                    el.timeBooking = booking.beautyBookingDetails[0].bookingDateStr + ' - ' + booking.beautyBookingDetails[0].startTime
                                    if (booking.beautyBookingDetails[0].beautyServicePackage) {
                                        el.serviceBookingName = booking.beautyBookingDetails[0].beautyServicePackage.name
                                    } else if (booking.beautyBookingDetails[0].beautyPackageCombo) {
                                        el.serviceBookingName = booking.beautyPackageCombo[0].beautyServicePackage.name
                                    }
                                }
                            })
                        }
                    }
                    this.$vs.loading.close()
                    resolve()
                }).catch(() => {
                    this.$vs.loading.close()
                    reject()
                });
            })
        },

        getUnknownCustomer() {
            return new Promise((resolve, reject) => {
                let searchInfo = {
                    start: this.dateRange.startDate,
                    end: this.dateRange.endDate,
                    organizationBranchId: this.branchId,
                    faceTypes: ["unknown"],
                    // pageNumber: this.pageNumberUnknown,
                    // pageSize: this.pageSizeUnknown
                }
                this.customerUnknownData = []
                let url = `/processor/in-out-history/all?page=${this.pageNumberUnknown}&size=${this.pageSizeUnknown}`
                this.$vs.loading()
                this.$processor.post(url, searchInfo).then((response) => {
                    let customerData = response.data.content.map((item) => {
                        item.checkinTime = item.createdAt ? moment(item.createdAt).format("HH:mm DD/MM/YYYY") : null
                        let branch = this.listBranch.find(
                            (el) => el.id === item.organizationBranchId
                        );
                        if (item.faceType === "unknown") item.customerType = this.$t('cardCustomer.unknown')
                        if (branch)
                            item.organizationBranchName = branch.organizationBranchName
                        return item;
                    }, []);
                    if (customerData) {
                        this.customerUnknownData = customerData
                        this.customerUnknownData = this.customerUnknownData.filter(el => el.faceType === 'unknown').slice(0, 60)
                        let compare = JSON.stringify(this.customerUnknownData) === JSON.stringify(customerData)
                        if (!compare || this.totalPagesUnknown !== response.data.totalPages || this.pageSizeUnknown !== response.data.size || this.totalElementsUnknown !== response.data.totalElements) {
                            this.pageDataUnknown = response.data
                            this.totalPagesUnknown = response.data.totalPages
                            this.totalElementsUnknown = response.data.totalElements
                            this.customerUnknownData = customerData.filter(el => el.faceType === 'unknown')
                        }
                    }
                    this.$vs.loading.close()
                    resolve()
                }).catch(() => {
                    this.$vs.loading.close()
                    reject()
                });
            })
        },

        // getCustomers() {
        //     return new Promise((resolve) => {
        //         this.$crm.get(`/customer/find-all`).then((response) => {
        //             response.data.forEach((x) =>
        //                 (x.created_at_display = moment(x.created_at).format(
        //                     "DD/MM/YYYY HH:mm:ss"
        //                 ))
        //             );
        //             this.customers = response.data;
        //             this.customerOptions = response.data.map((item) => {
        //                 return {
        //                     value: item.id,
        //                     label: item.customerCode + " " + item.fullName,
        //                 };
        //             });
        //             this.customerOptions.unshift({
        //                 value: null, label: this.$t("menuCustomer.all"),
        //             });
        //             resolve(true);
        //         }).catch((err) => {
        //             this.$vs.loading.close();
        //             this.$vs.notify({
        //                 title: "Error",
        //                 text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //                 iconPack: "feather",
        //                 icon: "icon-alert-circle",
        //                 color: "danger",
        //             });
        //             resolve(false);
        //         });
        //     });
        // },

        search() {
            this.$vs.loading();
            this.pageNumberUnknown = 0;
            this.pageNumberLoyalty = 0;
            this.customerLoyaltyData = 1;
            this.currentPageUnknown = 1;
            this.filter();
        },

        setPageSizeUnknown(e) {
            this.pageSizeUnknown = e;
            this.pageNumberUnknown = 0;
            this.getUnknownCustomer();
        },

        setPageSizeLoyalty(e) {
            this.pageSizeLoyalty = e;
            this.pageNumberLoyalty = 0;
            this.getLoyaltyCustomer();
        },

        pauseCall() {
            clearInterval(this.stopInterval)
        },

        resumeCall() {
            if (!this.isOpenDetailsCustomer) {
                this.stopInterval = setInterval(() => {
                    this.filter();
                }, 20000)
            }
        },

        dateRangePicker: function () {
            this.pageNumberUnknown = 0;
            this.pageNumberLoyalty = 0;
        },

        changePageUnknown: function (currentPage) {
            if (this.pageNumberUnknown !== parseInt(currentPage) - 1) {
                this.pageNumberUnknown = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getUnknownCustomer();
            }
        },

        changePageLoyalty: function (currentPage) {
            if (this.pageNumberLoyalty !== parseInt(currentPage) - 1) {
                this.pageNumberLoyalty = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getLoyaltyCustomer();
            }
        },

        getDataBooking() {
            return new Promise((resolve, reject) => {
                let payload = {
                    endDate: new Date(this.dateRange.endDate).toISOString(),
                    startDate: new Date(this.dateRange.startDate).toISOString(),
                    status: 2
                };

                this.$crm.post('/beauty-booking/find-by-condition', payload).then(res => {
                    this.dataBooking = res.data.content;
                    resolve();
                }).catch(err => {
                    reject();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },

    // updated() {
    //     let heightUnknown = document.getElementById('unknown_data').clientHeight;
    //     let heightLoyalty = document.getElementById('loyalty_data').clientHeight;
    //     if (heightUnknown >= heightLoyalty) this.heightCard = heightUnknown + 'px';
    //     if (heightUnknown <= heightLoyalty) this.heightCard = heightLoyalty + 'px';
    // },
    beforeDestroy() {
        this.pauseCall()
    },

    destroyed() {
        this.pauseCall()
    },

    mounted() {
        this.$eventBus.$on('show-details-customer', (e) => {
            this.isOpenDetailsCustomer = e
            if (e) {
                this.pauseCall()
            } else {
                this.resumeCall()
            }
        })
    }

};
</script>

<style lang="scss">
.bg-image {
    // background-image: url('../../../assets/images/card/bg-card.png');
    height: 250px;
}

.border-status {
    padding: 4px;
    animation: borderHighlight 2s ease infinite;
    border-radius: 50%;
}

.status-success {
    border: 2px solid #04d361;
}

.status-warning {
    border: 2px solid #eb5455d1;
}

.border-info {
    border-radius: 0 5px 5px 0;
}

.status-danger {
    background-color: #eb5455d1;
}

@keyframes borderHighlight {
    50% {
        border-color: transparent;
    }
}

.table_realtime {
    padding: 0 0.25rem !important;
}
</style>
